import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollEffects = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });

    const frame = window.requestAnimationFrame(() => {
      const elements = document.querySelectorAll(
        ".reveal, .app-shell > div:not(.home-page):not(.about-page):not(.contact-page) > div > *"
      );

      if (!("IntersectionObserver" in window)) {
        elements.forEach((element) => element.classList.add("is-visible"));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.08, rootMargin: "0px 0px -30px" }
      );

      elements.forEach((element) => {
        element.classList.add("reveal");
        observer.observe(element);
      });

      window.__scrollRevealObserver = observer;
    });

    return () => {
      window.cancelAnimationFrame(frame);
      window.__scrollRevealObserver?.disconnect();
    };
  }, [pathname]);

  return null;
};

export default ScrollEffects;
